// Static curated content for MOVA

export const DESTINATIONS = [
  {
    id: "dubai",
    name: "Dubai",
    tag: "Luxury & Culture",
    price: "from $3,400",
    image: "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Gilded skylines, desert sanctuaries and the world's finest hospitality.",
  },
  {
    id: "paris",
    name: "Paris",
    tag: "Romance & Style",
    price: "from $2,800",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Haute couture, candle-lit bistros and timeless Parisian elegance.",
  },
  {
    id: "bali",
    name: "Bali",
    tag: "Nature & Wellness",
    price: "from $2,100",
    image: "https://images.unsplash.com/photo-1711609110590-5ad5c4599e56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Jungle villas, temple rituals and restorative island wellness.",
  },
  {
    id: "santorini",
    name: "Santorini",
    tag: "Views & Relaxation",
    price: "from $3,000",
    image: "https://images.unsplash.com/photo-1560703650-ef3e0f254ae0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Caldera sunsets, whitewashed suites and the bluest Aegean escapes.",
  },
];

export const CATEGORIES = [
  {
    id: "travel",
    title: "Travel",
    icon: "Plane",
    desc: "Flights, hotels, experiences and group trips.",
    cta: "Explore",
    href: "/travel",
    image: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "fashion",
    title: "Fashion",
    icon: "ShoppingBag",
    desc: "Shop top brands with exclusive deals.",
    cta: "Shop Now",
    href: "/fashion",
    image: "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "self-care",
    title: "Self-Care",
    icon: "Flower2",
    desc: "Book spas, salons, fitness and wellness services.",
    cta: "Book Now",
    href: "/self-care",
    image: "https://images.unsplash.com/photo-1720118509152-2df877673bee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "lifestyle",
    title: "Lifestyle",
    icon: "Compass",
    desc: "Manage your goals, budget and everyday needs.",
    cta: "Start Planning",
    href: "/lifestyle",
    image: "https://images.pexels.com/photos/7902912/pexels-photo-7902912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const TRIP_FILTERS = ["All", "Flights", "Hotels", "Experiences", "Group Trips"];

export const TRIPS = [
  { id: "t1", type: "Flights", title: "Private Jet — Nice to Mykonos", price: "$6,900", image: "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "Seamless island hop aboard a chartered light jet." },
  { id: "t2", type: "Hotels", title: "Overwater Suite — Maldives", price: "$1,250 / night", image: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "Glass-floor villa with private infinity deck." },
  { id: "t3", type: "Experiences", title: "Desert Dinner Under Stars", price: "$480 pp", image: "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "Private chef, falconry and dunes at golden hour." },
  { id: "t4", type: "Group Trips", title: "Bali Wellness Retreat — 6 days", price: "$2,100 pp", image: "https://images.unsplash.com/photo-1555400038-63f5ba517a47?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "Yoga, rice-terrace treks and curated sound healing." },
  { id: "t5", type: "Hotels", title: "Cliffside Suite — Santorini", price: "$980 / night", image: "https://images.unsplash.com/photo-1618500031461-a5fc01e96763?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "Caldera views, private plunge pool, sunset terrace." },
  { id: "t6", type: "Experiences", title: "Paris After Hours — Louvre", price: "$620 pp", image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", blurb: "After-hours gallery access with a private curator." },
];

export const BRANDS = [
  { id: "f1", name: "Atelier Noir", cat: "Womenswear", deal: "-30% new season", image: "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "f2", name: "Maison Lux", cat: "Tailoring", deal: "Members only", image: "https://images.unsplash.com/photo-1629511565591-a1d494ad6c58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "f3", name: "Studio Mono", cat: "Editorial", deal: "Early access", image: "https://images.pexels.com/photos/38290951/pexels-photo-38290951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "f4", name: "Sable & Co.", cat: "Accessories", deal: "-20% today", image: "https://images.pexels.com/photos/35733628/pexels-photo-35733628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const SERVICES = [
  { id: "s1", name: "Signature Spa Ritual", cat: "Spa", duration: "120 min", price: "$260", image: "https://images.unsplash.com/photo-1720118509152-2df877673bee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "s2", name: "Aromatherapy & Massage", cat: "Wellness", duration: "90 min", price: "$180", image: "https://images.unsplash.com/photo-1706795033917-dee116e7cba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "s3", name: "Private Salon Styling", cat: "Salon", duration: "75 min", price: "$140", image: "https://images.pexels.com/photos/35884502/pexels-photo-35884502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "s4", name: "1:1 Fitness & Recovery", cat: "Fitness", duration: "60 min", price: "$110", image: "https://images.pexels.com/photos/1926811/pexels-photo-1926811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
export const TRAVEL_FEATURE_IMAGE = "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
